<template>
    <nav class="navbar navbar-inverse navbar-fixed-top">
        <div class="container-fluid">
            <div class="navbar-header">
                <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar"
                        aria-expanded="false" aria-controls="navbar">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
                <a class="navbar-brand" href="#/">
                    <img src="image/logo.png" style="height: 20px">
                </a>
            </div>
            <div v-if="!user" id="navbar" class="collapse navbar-collapse">
                <ul class="nav navbar-nav navbar-right">
                    <li class="dropdown">
                        <a href="#/login">
                            <i class="fa fa-user-circle" aria-hidden="true"></i> ACESSAR
                        </a>
                    </li>
                </ul>
            </div>
            <div v-else id="navbar" class="collapse navbar-collapse">

                <ul class="nav navbar-nav" v-if="user.level > 4">
                    <li class="dropdown">
                        <a class="dropdown-toggle" data-toggle="dropdown" href="#" id="cadastros">
                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i> CADASTROS <span
                            class="caret"></span>
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="themes">

                            <li v-if="user.level === 1">
                                <hr>
                            </li>

                            <li>
                                <a href="#/contratos">
                                    <i class="fa fa-suitcase" aria-hidden="true"></i> CONTRATOS
                                </a>
                            </li>

                        </ul>
                    </li>
                </ul>

                <ul class="nav megamenu navbar-nav" e-else>
                    <li class="dropdown mega-dropdown">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                            CADASTROS <span class="caret"></span>
                        </a>

                        <ul class="dropdown-menu  mega-dropdown-menu row">
                            <li class="col-sm-3">
                                <ul>
                                    <li class="dropdown-header">MONITORES</li>
                                    <li v-if="user.level === 1">
                                        <a :href="'#/pops'">
                                            <i class="fa fa-building" aria-hidden="true"></i> POPS
                                        </a>
                                    </li>
                                    <li v-if="user.level >= 1 && user.level < 5">
                                        <a href="#/concentradores">
                                            <i class="fa fa-hashtag" aria-hidden="true"></i> CONCENTRADORES
                                        </a>
                                    </li>
                                    <li v-if="user.level >= 1 && user.level < 5">
                                        <a href="#/vlans">
                                            <i class="fa fa-hashtag" aria-hidden="true"></i> VLANS
                                        </a>
                                    </li>
                                </ul><br/>
                                <ul>
                                    <li class="dropdown-header">ONUs</li>
                                    <li v-if="user.level === 1">
                                        <a href="#/relatorio/onu-unregistered">
                                            <i class="fa fa-chart-bar" aria-hidden="true"></i> ATIVAR ONU
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li class="col-sm-3">
                                <ul>
                                    <li class="dropdown-header">CAIXAS</li>
                                    <li v-if="user.level === 1">
                                        <a :href="'#/caixas-cto'">
                                            <i class="fa fa-box" aria-hidden="true"></i> CAIXAS CTO
                                        </a>
                                    </li>

                                    <li v-if="user.level === 1">
                                        <a :href="'#/caixas-pacpon'">
                                            <i class="fa fa-box" aria-hidden="true"></i> CAIXAS PAC-PON
                                        </a>
                                    </li>

                                    <li v-if="user.level === 1">
                                        <a :href="'#/caixas-switch'">
                                            <i class="fa fa-box" aria-hidden="true"></i> CAIXAS PAC-SWITCH
                                        </a>
                                    </li>

                                    <li v-if="user.level === 1">
                                        <a :href="'#/reservas-tecnicas'">
                                            <i class="fa fa-discourse" aria-hidden="true"></i> RESERVAS TÉCNICAS
                                        </a>
                                    </li>

                                    <li v-if="user.level === 1">
                                        <a :href="'#/caixas-conectores'">
                                            <i class="fa fa-sort-numeric-up" aria-hidden="true"></i> CAIXAS COM CONECTORES
                                        </a>
                                    </li>

                                    <li v-if="user.level === 1">
                                        <a :href="'#/caixas-emendas'">
                                            <i class="fa fa-band-aid" aria-hidden="true"></i> CAIXAS DE EMENDA
                                        </a>
                                    </li>

                                    <li class="divider"></li>

                                    <li v-if="user.level === 1">
                                        <a :href="'#/portas-pon'">
                                            <i class="fa fa-sort-numeric-up" aria-hidden="true"></i> PORTAS PON
                                        </a>
                                    </li>

                                    <li v-if="user.level === 1">
                                        <a :href="'#/fibras'">
                                            <i class="fa fa-certificate" aria-hidden="true"></i> FIBRAS
                                        </a>
                                    </li>
                                    <li v-if="user.level === 1">
                                        <a :href="'#/splitters'">
                                            <i class="fa fa-american-sign-language-interpreting" aria-hidden="true"></i> SPLITTERS
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li class="col-sm-3">
                                <ul>
                                    <li class="dropdown-header">GERAIS</li>
                                    <li v-if="user.level === 0">
                                        <router-link to="/empresas">
                                            <i class="fa fa-suitcase" aria-hidden="true"></i> EMPRESAS
                                        </router-link>
                                    </li>
                                    <li v-if="user.level === 1">
                                        <router-link to="/smtps">
                                            <i class="fa fa-at" aria-hidden="true"></i> SMTP
                                        </router-link>
                                    </li>
                                    <li v-if="user.level === 1">
                                        <router-link to="/condominios">
                                            <i class="fa fa-building" aria-hidden="true"></i> CONDOMÍNIOS
                                        </router-link>
                                    </li>

                                    <li v-if="user.level >= 1 && user.level <= 100">
                                        <router-link to="/contratos">
                                            <i class="fa fa-suitcase" aria-hidden="true"></i> CONTRATOS
                                        </router-link>
                                    </li>

                                    <li v-if="user.level >= 1 && user.level < 5">
                                        <router-link to="/clientes">
                                            <i class="fa fa-users" aria-hidden="true"></i> CLIENTES
                                        </router-link>
                                    </li>

                                    <li v-if="user.level === 1">
                                        <router-link to="/planos-internet">
                                            <i class="fa fa-credit-card" aria-hidden="true"></i> PLANOS DE INTERNET
                                        </router-link>
                                    </li>

                                    <li v-if="user.level === 1">
                                        <router-link to="/modelos-switch">
                                            <i class="fa fa-credit-card" aria-hidden="true"></i> MODELOS DE SWITCH
                                        </router-link>
                                    </li>

                                    <!--
                                    <li v-if="user.level === 1">
                                        <a href="#/pontos">
                                            <i class="fa fa-id-card-o" aria-hidden="true"></i> PONTOS
                                        </a>
                                    </li>

                                    <li v-if="user.level = 1">
                                        <a href="#/repetidores">
                                            <i class="fa fa-id-card-o" aria-hidden="true"></i> REPETIDORES
                                        </a>
                                    </li>
                                    -->

                                    <li v-if="user.level >= 1 && user.level < 5">
                                        <a href="#/usuarios">
                                            <i class="fa fa-user-circle" aria-hidden="true"></i> USUÁRIOS
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li class="col-sm-3">
                                <ul>
                                    <li class="dropdown-header">ATENDIMENTOS</li>
                                    <li v-if="user.level >= 1 && user.level < 3">
                                        <a href="#/atendimento-acoes">
                                            <i class="fa fa-code-branch" aria-hidden="true"></i> AÇÕES DO MONITOR
                                        </a>
                                    </li>
                                    <li v-if="user.level >= 1 && user.level < 3">
                                        <a href="#/atendimento-motivo">
                                            <i class="fa fa-exclamation" aria-hidden="true"></i> MOTIVOS DA LIGAÇÃO
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>

                    </li>
                </ul>
                <ul class="nav navbar-nav" v-if="user">
                    <li class="dropdown" v-if="user.level >= 1 && user.level < 100">
                        <a class="dropdown-toggle" data-toggle="dropdown" href="#" id="acoes">
                            <i class="fa fa-cogs" aria-hidden="true"></i> AÇÕES <span class="caret"></span>
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="themes" v-if="user.permissoes">
                            <li v-if="user.permissoes.comandos && user.level < 5">
                                <a href="#/comandos-todos">
                                    <i class="fa fa-share-square" aria-hidden="true"></i> ENVIAR COMANDOS PARA TODOS OS
                                    CLIENTES
                                </a>
                            </li>
                            <li v-if="user.permissoes.comandos && user.level < 5">
                                <a href="#/comandos-todos-concentradores">
                                    <i class="fa fa-share-square" aria-hidden="true"></i> ENVIAR COMANDOS PARA TODOS
                                    OS CONCENTRADORES
                                </a>
                            </li>

                            <li v-if="user.permissoes.comandos && user.level < 5">
                                <a href="#/burst">
                                    <i class="fa fa-share-square" aria-hidden="true"></i> HABILITAR / DESABILITAR BURST NOS CONTRATOS
                                </a>
                            </li>

                            <!--
                            <li v-if="user.permissoes.comandos && user.level < 5">
                                <a href="#/logs-radius">
                                    <i class="fa fa-share-square-o" aria-hidden="true"></i> LOGS DO RADIUS
                                </a>
                            </li>

                            <li v-if="user.level === 1">
                                <a href="#/icinga">
                                    <i class="fa fa-share-square-o" aria-hidden="true"></i> ICINGA
                                </a>
                            </li>
                            -->
                        </ul>
                    </li>
                    <li class="dropdown" v-if="user.level >= 1 && user.level < 100">
                        <a class="dropdown-toggle" data-toggle="dropdown" href="#" id="maps">
                            <i class="fa fa-map" aria-hidden="true"></i> MAPAS <span class="caret"></span>
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="themes">
                            <li>
                                <a href="#/mapa-geral">
                                    <i class="fa fa-location-arrow" aria-hidden="true"></i> MAPA GERAL
                                </a>
                                <a href="/maps" target="_blank">
                                    <i class="fa fa-location-arrow" aria-hidden="true"></i> MAPA COMPLETO
                                </a>
                            </li>
                        </ul>
                    </li>
                    <ul class="nav megamenu navbar-nav" v-if="user.level >= 1 && user.level < 100">
                        <li class="dropdown mega-dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                                <i class="fa fa-chart-pie" aria-hidden="true"></i>
                                RELATÓRIO <span class="caret"></span>
                            </a>

                            <ul class="dropdown-menu  mega-dropdown-menu row">
                                <li class="col-sm-3">
                                    <ul>
                                        <li class="dropdown-header">BUSCAS</li>
                                        <li v-if="user.level === 1">
                                            <router-link to="/relatorio/busca-cliente-ipv6">
                                                <i class="fa fa-search" aria-hidden="true"></i> BUSCA CLIENTE COM IPV6
                                            </router-link>
                                        </li>
                                        <li v-if="user.level >= 1 && user.level < 5">
                                            <router-link to="/relatorio/busca-contrato">
                                                <i class="fa fa-search" aria-hidden="true"></i> BUSCA CONTRATO COM MAC
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link to="/relatorio/cgnat">
                                                <i class="fa fa-search" aria-hidden="true"></i> CGNAT
                                            </router-link>
                                        </li>
                                    </ul>
                                </li>
                                <li class="col-sm-3">
                                    <ul>
                                        <li class="dropdown-header">PROBLEMAS COM CONTRATOS</li>
                                        <li v-if="user.level === 1">
                                            <a href="#/relatorio/no-latlng">
                                                <i class="fa fa-thumbtack" aria-hidden="true"></i> CONTRATOS SEM LAT LONG
                                            </a>
                                        </li>

                                        <li v-if="user.level === 1">
                                            <a href="#/relatorio/no-caixa">
                                                <i class="fa fa-chart-bar" aria-hidden="true"></i> CONTRATOS FIBRA SEM CAIXA
                                            </a>
                                        </li>

                                        <li v-if="user.level === 1">
                                            <a href="#/relatorio/no-ipv6">
                                                <i class="fa fa-thumbtack" aria-hidden="true"></i> CONTRATOS SEM IPV6
                                            </a>
                                        </li>

                                        <li v-if="user.level === 1">
                                            <a href="#/relatorio/no-mac">
                                                <i class="fa fa-thumbtack" aria-hidden="true"></i> CONTRATOS SEM MAC
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                                <li class="col-sm-3">
                                    <ul>
                                        <li class="dropdown-header">GERAIS</li>
                                        <li>
                                            <a href="#/relatorio/banda">
                                                <i class="fa fa-chart-bar" aria-hidden="true"></i> BANDA CONTRATADA
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                                <li class="col-sm-3">
                                    <ul>
                                        <li class="dropdown-header">PROBLEMAS COM CAIXAS</li>
                                        <li v-if="user.level === 1">
                                            <a href="#/relatorio/no-vlan">
                                                <i class="fa fa-thumbtack" aria-hidden="true"></i> PACPON SEM VLAN
                                            </a>
                                        </li>

                                        <li v-if="user.level === 1">
                                            <a href="#/relatorio/no-onuid">
                                                <i class="fa fa-chart-bar" aria-hidden="true"></i> PACPON SEM ONU-ID
                                            </a>
                                        </li>

                                        <li v-if="user.level === 1">
                                            <a href="#/relatorio/pacpon/sinal">
                                                <i class="fa fa-chart-bar" aria-hidden="true"></i> PACPON COM PROBLEMAS DE SINAL
                                            </a>
                                        </li>


                                    </ul>
                                </li>
                            </ul>

                        </li>
                    </ul>
                </ul>
                <ul class="nav navbar-nav">
                    <li class="dropdown">
                        <a class="dropdown-toggle" data-toggle="dropdown">
                            <i class="fa fa-map" aria-hidden="true"></i> MONITORAMENTO <span class="caret"></span>
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="themes">
                            <li>
                                <a href="#/monitoramento">
                                    <i class="fa fa-terminal" aria-hidden="true"></i> PAINEL GERAL
                                </a>
                                <a href="#/onus-off">
                                    <i class="fa fa-share" aria-hidden="true"></i> ALERTAS - ONUs OFFLINE
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>

                <ul class="nav navbar-nav navbar-right">
                    <li class="dropdown">
                        <a class="dropdown-toggle" data-toggle="dropdown" href="#" id="themes">
                            <i class="fa fa-user-circle" aria-hidden="true"></i> {{ user.nome | uppercase }} <span
                            class="caret"></span>
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="themes">
                            <!--<li><a href="#/clientes">ALTERAR SENHA</a></li>-->
                            <li v-if="user.level === 1">
                                <a href="#/config">
                                    <i class="fa fa-plug" aria-hidden="true"></i> CONFIGURAÇÕES
                                </a>
                            </li>
                            <li>
                                <a style="cursor: pointer" @click="logout()">
                                    <i class="fa fa-sign-out" aria-hidden="true"></i> SAIR
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <!--/.nav-collapse -->
        </div>
    </nav>
</template>
<script>
export default {
    data() {
        return {
            user: null
        };
    },
    mounted() {
        this.user = this.$store.state.user;
    },
    methods: {
        logout() {
            window.localStorage.clear();
            this.$store.commit("login", null);
            this.$router.push({ path: "/login" });
        }
    }
};

// eslint-disable-next-line no-undef
jQuery(document).on("click", ".mega-dropdown", function(e) {
    e.stopPropagation();
});
</script>
<style>
.megamenu > li > .dropdown-menu {
    margin-top: 20px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.navbar-default .navbar-nav > li > a {
    width: 200px;
    font-weight: bold;
}

.mega-dropdown {
    position: static !important;
    width: 100%;
}

.mega-dropdown-menu {
    padding: 20px 0px;
    width: 100%;
    box-shadow: none;
    -webkit-box-shadow: none;
}

.mega-dropdown-menu:before {
    content: "";
    border-bottom: 15px solid #fff;
    border-right: 17px solid transparent;
    border-left: 17px solid transparent;
    position: absolute;
    top: -15px;
    left: 205px;
    z-index: 10;
}

.mega-dropdown-menu:after {
    content: "";
    border-bottom: 17px solid #ccc;
    border-right: 19px solid transparent;
    border-left: 19px solid transparent;
    position: absolute;
    top: -17px;
    left: 203px;
    z-index: 8;
}

.mega-dropdown-menu > li > ul {
    padding: 0;
    margin: 0;
}

.mega-dropdown-menu > li > ul > li {
    list-style: none;
}

.mega-dropdown-menu > li > ul > li > a {
    display: block;
    padding: 3px 20px;
    clear: both;
    font-weight: normal;
    line-height: 1.428571429;
    color: #999;
    white-space: normal;
}

.mega-dropdown-menu > li ul > li > a:hover,
.mega-dropdown-menu > li ul > li > a:focus {
    text-decoration: none;
    color: #444;
    background-color: #f5f5f5;
}

.mega-dropdown-menu .dropdown-header {
    color: #428bca;
    font-size: 18px;
    font-weight: bold;
}

.mega-dropdown-menu form {
    margin: 3px 20px;
}

.mega-dropdown-menu .form-group {
    margin-bottom: 3px;
}
</style>
